// extracted by mini-css-extract-plugin
export var closeButton = "_kw-1";
export var closeX = "_kw-3";
export var container = "_kw-0";
export var image = "_kw-2";